import {Link} from 'react-router-dom';
import {toAbsoluteUrl} from '../../../../_metronic/helpers';
import {useIntl} from 'react-intl';

const Error401 = (): JSX.Element => {
    const intl = useIntl();

    return (
        <>
            <h1 className="fw-bolder fs-2hx text-gray-900 mb-4">Oops!</h1>
            <div className="fw-semibold fs-6 text-gray-500 mb-7">
                {intl.formatMessage({id: 'ERROR_PAGE.NOT_AUTHORIZED'})}
            </div>
            <div className="mb-3">
                <img
                    src={toAbsoluteUrl('/media/auth/please-verify-your-email.png')}
                    className="mw-100 mh-300px theme-light-show"
                    alt=""
                />
                <img
                    src={toAbsoluteUrl('/media/auth/please-verify-your-email-dark.png')}
                    className="mw-100 mh-300px theme-dark-show"
                    alt=""
                />
            </div>
            <div className="mb-0">
                <Link to="/dashboard" className="btn btn-sm btn-primary">
                    {intl.formatMessage({id: 'ERROR_PAGE.RETURN_HOME'})}
                </Link>
            </div>
        </>
    );
};

export default Error401;
